//@flow
const stateName = 'ftTransferStats'
const sessionStore = sessionStorage.getItem(stateName)

export const getStateName=(): string => {
    return stateName
}

export const ftTransferStatsInitialState: any = sessionStore ? JSON.parse(sessionStore) : {
    [stateName]: {
        error: '',
        // dashboard uses large pageSize to fetch all rows so summary cards aggregate the full date range
        dashboard: { loading: false, datas: [], count: 0, page: 1, pages: 0, pageSize: 10000 },
        dailySummary: { loading: false, datas: [], count: 0, page: 1, pages: 0, pageSize: 10, sortField: 'transfer_date', sortOrder: 'desc' },
        incidents: { loading: false, datas: [], count: 0, page: 1, pages: 0, pageSize: 10, sortField: 'created_at', sortOrder: 'desc' },
        cronHealth: { loading: false, datas: [], count: 0, page: 1, pages: 0, pageSize: 10, sortField: 'ft_key', sortOrder: 'asc' },
        dateFrom: '',
        dateTo: ''
    }
}

export const TypeFtTransferStatsFetch = 'ftTransferStatsFetch'
export const TypeFtTransferStatsReceived = 'ftTransferStatsReceived'
export const TypeFtTransferStatsError = 'ftTransferStatsError'
export const TypeFtTransferStatsSetDates = 'ftTransferStatsSetDates'

export const ftTransferStatsActions: any = {
    [TypeFtTransferStatsFetch]: (state: any, action: any) => {
        return {
            [stateName]: {
                ...state[stateName],
                [action.dataKey]: {
                    ...state[stateName][action.dataKey],
                    loading: true,
                    error: ''
                }
            }
        }
    },
    [TypeFtTransferStatsReceived]: (state: any, action: any) => {
        return {
            [stateName]: {
                ...state[stateName],
                [action.dataKey]: {
                    ...state[stateName][action.dataKey],
                    loading: false,
                    error: '',
                    datas: action.pageData.results || [],
                    page: action.pageData.page || 1,
                    pages: action.pageData.pages || 0,
                    count: action.pageData.count || 0,
                    pageSize: action.pageData.pageSize || 10,
                    sortField: action.pageData.sortField || '',
                    sortOrder: action.pageData.sortOrder || '',
                    search: action.pageData.search || ''
                }
            }
        }
    },
    [TypeFtTransferStatsError]: (state: any, action: any) => {
        return {
            [stateName]: {
                ...state[stateName],
                [action.dataKey]: {
                    ...state[stateName][action.dataKey],
                    loading: false,
                    error: action.error,
                    datas: []
                }
            }
        }
    },
    [TypeFtTransferStatsSetDates]: (state: any, action: any) => {
        const thisState = {
            [stateName]: {
                ...state[stateName],
                dateFrom: action.dateFrom,
                dateTo: action.dateTo
            }
        }
        sessionStorage.setItem(stateName, JSON.stringify(thisState))
        return thisState
    }
}
